<template lang="pug">
  component(ref="processViewComponent" :is="view" v-if="definition" :loading="loading || submitMode")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import minioAPI from '@/services/minio'
import dictionariesAPI from '@/services/dictionaries'
import validationFocus from '@/utils/validationFocus'

export default {
  name: 'ProcessStartController',

  provide() {
    const that = this
    return {
      ctrl: {
        submit(variables) {
          that.submit({ definitionKey: that.definition.key, variables: variables || [] })
        },
        // Запустить ещё один инстанс этого же процесса. Возвращает промис,
        // редиректа нет — форма сама решает, что делать дальше.
        startInstance(variables) {
          return that.startInstance({ definitionKey: that.definition.key, variables: variables || [] })
        },
        save(variables) {
          that.save(variables)
        },
        restore() {
          return that.restore()
        },
        isDirty(form) {
          return form.inputs.some(input => input.hasInput)
        },
        get(name, alt) {
          return that.variables[name] ? that.variables[name].value : alt
        },
        getDownloadUrls(files) {
          if (files) {
            return minioAPI.presignedGetObjectUrls(files)
          }
          return null
        },
        getDictionary(dictionary, payload) {
          return dictionariesAPI.request(dictionary, payload)
        },
        getСancelableDictionary(dictionary, payload) {
          return dictionariesAPI.cancelableRequest(dictionary, payload)
        },
        getCurrentUser() {
          return Object.assign(that.profile, { groups: that.groups, locale: that.locale })
        },
        confirm(payload) {
          return that.showConfirm({ title: payload.title,
            text: payload.text,
            persistent: payload.persistent,
            resolveText: payload.resolveText ? payload.resolveText : that.$tf('process.start.yes'),
            rejectText: payload.rejectText ? payload.rejectText : that.$tf('process.start.no') })
        },
        alert(title) {
          that.setSnackbar(title)
        },
        focusOnInvalid(form) {
          validationFocus.focusOnFirstInvalidOf(form)
        },
        t(key) {
          return that.$tf(`${that.definition.key}.${key}`)
        },
        routerPush(arg) {
          return that.$router.push(arg)
        },
      },
    }
  },

  computed: {
    ...mapGetters({
      view: 'process/view',
      definition: 'process/definition',
      variables: 'process/variables',
      submitMode: 'process/submitMode',
      loading: 'tools/loading',
      profile: 'auth/profile',
      groups: 'auth/groups',
      locale: 'tools/locale',
    }),
  },

  mounted() {
    if (localStorage.getItem(`process-start-vars-${this.definition.key}`)) {
      this.showConfirm({
        title: this.$tf('process.start.restoreLastChanges'),
        persistent: true,
        resolveText: this.$tf('process.start.restore'),
        rejectText: this.$tf('process.start.no') })
        .then(() => {
          this.$refs.processViewComponent.$restore()
        }).catch(() => {
          localStorage.removeItem(`process-start-vars-${this.definition.key}`)
        })
    }
  },

  methods: {
    ...mapActions({
      submit: 'process/submit',
      startInstance: 'process/startInstance',
      save: 'process/save',
      restore: 'process/restore',
      showConfirm: 'tools/showConfirm',
      setSnackbar: 'tools/setSnackbar',
    }),
  },

  beforeRouteLeave(to, from, next) {
    if (!this.submitMode && this.$refs.processViewComponent && this.$refs.processViewComponent.$dirty && this.$refs.processViewComponent.$dirty()) {
      this.showConfirm({
        title: this.$tf('process.start.saveChanges'),
        persistent: true,
        resolveText: this.$tf('process.start.save'),
        rejectText: this.$tf('process.start.no') })
        .then(() => {
          this.$refs.processViewComponent.$save()
          next()
        }).catch(() => {
          next()
        })
    } else {
      next()
    }
  },
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// src/components/process/ProcessStartController.vue